/** Fixed upstreams for the standalone Vite development proxy. */
export const DEVELOPMENT_PROXY_TARGETS = {
  gateway: 'https://atlas-staging.solidum-invest.de',
  websocket: 'https://atlas-staging.solidum-invest.de/websocket',
  static: 'https://atlas-staging.solidum-invest.de/static-file',
  pdf: 'https://atlas-staging.solidum-invest.de/pdf',
  sync: 'https://atlas-staging.solidum-invest.de/sync',
  editing: 'https://atlas-staging.solidum-invest.de/ai-editing',
} as const;

export const DEVELOPMENT_PROXY_PREFIX = '/__atlas_dev';

/** Keep hosted development APIs on the page origin, including workers and WS. */
export function developmentProxyUrl(url: string): string {
  if (
    (import.meta.env.VITE_DEV_PROXY !== true &&
      import.meta.env.VITE_DEV_PROXY !== 'true') ||
    !globalThis.location?.origin
  )
    return url;
  const parsed = new URL(url);
  const httpOrigin = parsed.origin.replace(/^ws/, 'http');
  // Prefer the most specific path. Several Atlas services share an origin.
  const target = Object.entries(DEVELOPMENT_PROXY_TARGETS)
    .sort((a, b) => b[1].length - a[1].length)
    .find(([, base]) => {
      const candidate = new URL(base);
      const path = candidate.pathname.replace(/\/$/, '');
      return (
        candidate.origin === httpOrigin &&
        (parsed.pathname === path || parsed.pathname.startsWith(`${path}/`))
      );
    });
  if (!target) return url;
  const pageOrigin = parsed.protocol.startsWith('ws')
    ? globalThis.location.origin.replace(/^http/, 'ws')
    : globalThis.location.origin;
  const basePath = new URL(target[1]).pathname.replace(/\/$/, '');
  const path = parsed.pathname.slice(basePath.length).replace(/^\/$/, '');
  return `${pageOrigin}${DEVELOPMENT_PROXY_PREFIX}/${target[0]}${path}${parsed.search}${parsed.hash}`;
}
